import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Modal,
  Form,
  Checkbox,
  Button,
  Message,
  Placeholder,
} from "semantic-ui-react";
// import { makeStyles, createStyles } from "@material-ui/styles";
import { Transition } from "semantic-ui-react";

// export const useStyles = makeStyles((theme: any) =>
//   createStyles({
//     text: {},
//   })
// );

const DocerEditDoc = (props: any) => {
  // const classes = useStyles();
  const titleRef = useRef<any>(null);
  const idRef = useRef<any>(null);
  const lockedRef = useRef<any>(null);
  const [error, setError] = useState("");

  const workIt = () => {
    props.editDoc.action(
      idRef.current.value,
      titleRef.current.value,
      lockedRef.current.state.checked
    );

    props.setEditDoc({ ...props.editDoc, open: false });
  };

  const checkMe = useCallback(() => {
    let tempError = "";
    if (!titleRef.current.value) {
      tempError = "Please add a valid title.";
    }

    if (
      props.editDoc.new &&
      props.editDoc.activeList.find(
        (item: any) => item.id === idRef.current.value
      )
    ) {
      tempError = tempError + " Use a unique ID.";
    }

    if (!idRef.current.value) {
      tempError = tempError + " Use a unique ID.";
    }
    setError(tempError);
  }, [props.editDoc.activeList, props.editDoc.new]);

  useEffect(() => {
    checkMe();
  }, [checkMe]);

  return (
    <React.Fragment>
      <Modal
        size={"small"}
        open={props.editDoc.open}
        onClose={() => props.setEditDoc({ ...props.editDoc, open: false })}
      >
        <Modal.Header>
          {props.editDoc.new ? "Add new text..." : "Change text..."}
        </Modal.Header>

        <Modal.Content>
          <Form>
            <Form.Field required>
              <label>Text Title</label>
              <input
                ref={titleRef}
                name="title"
                onChange={checkMe}
                placeholder="Title..."
                defaultValue={props.editDoc.value.title}
              />
            </Form.Field>

            <Form.Field required>
              <label>Text ID</label>
              <input
                ref={idRef}
                onChange={checkMe}
                disabled={!props.editDoc.new}
                name="id"
                placeholder="ID..."
                defaultValue={props.editDoc.value.id}
              />
            </Form.Field>
            <Form.Field>
              <Checkbox
                ref={lockedRef}
                onChange={checkMe}
                name="locked"
                toggle
                label="locked"
                defaultChecked={!!props.editDoc.value.locked}
              />
            </Form.Field>
          </Form>
          <Transition visible={!!error}>
            <Message color="red">
              {error || (
                <Placeholder>
                  <Placeholder.Line />
                </Placeholder>
              )}
            </Message>
          </Transition>
        </Modal.Content>
        <Modal.Actions>
          <Button
            negative
            onClick={() => {
              props.setEditDoc({ ...props.editDoc, open: false });
            }}
          >
            Cancel
          </Button>
          <Button positive onClick={workIt}>
            {props.editDoc.new ? "Add" : "Save"}
          </Button>
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  );
};

export default DocerEditDoc;
